<template>
  <div class="menu">
    <nav class="menu__item d-flex align-center">
      <router-link to="/catalog">Каталог курсов</router-link>
      <router-link active-class="active" to="/about">О проекте</router-link>
      <router-link active-class="active" to="/news">Новости</router-link>
    </nav>
    <login-dialog v-model="showDialog" />
    <nav class="menu__item d-flex align-center">
      <a v-if="!$auth.user().id" @click.prevent="login()" href="#">Войти</a>
      <template v-else>
        <a class="mr-8" @click.prevent="$router.push('/me')" href="#">
          <svg class="non-transform" width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="46" height="46" rx="23" fill="#ededed"/>
            <path d="M30.6634 30.6667V28.7501C30.6634 27.7334 30.2595 26.7584 29.5407 26.0395C28.8218 25.3206 27.8467 24.9167 26.8301 24.9167H19.1634C18.1467 24.9167 17.1717 25.3206 16.4528 26.0395C15.7339 26.7584 15.3301 27.7334 15.3301 28.7501V30.6667" stroke="#1F1F1F" stroke-width="1.94595" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M22.9974 21.0834C25.1145 21.0834 26.8307 19.3672 26.8307 17.2501C26.8307 15.133 25.1145 13.4167 22.9974 13.4167C20.8803 13.4167 19.1641 15.133 19.1641 17.2501C19.1641 19.3672 20.8803 21.0834 22.9974 21.0834Z" stroke="#1F1F1F" stroke-width="1.94595" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
        <a v-if="$auth.check(['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])" class="mr-8 profile" href="/admin/profile">
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               width="507.451px" height="507.45px" viewBox="0 0 507.451 507.45" style="enable-background:new 0 0 507.451 507.45;"
               xml:space="preserve">
            <g>
              <g id="settings">
                <path d="M440.813,280.5c0-7.65,2.55-15.3,2.55-25.5s0-17.85-2.55-25.5l53.55-43.35c5.1-5.1,5.1-10.2,2.55-15.3l-51-89.25
                  c-2.55-2.55-7.649-5.1-15.3-2.55l-63.75,25.5c-12.75-10.2-28.05-17.85-43.35-25.5l-10.2-66.3C315.863,5.1,308.212,0,303.113,0
                  h-102c-5.101,0-12.75,5.1-12.75,10.2l-10.2,68.85c-15.3,5.1-28.05,15.3-43.35,25.5l-61.2-25.5c-7.65-2.55-12.75,0-17.851,5.1
                  l-51,89.25c-2.55,2.55,0,10.2,5.1,15.3l53.55,40.8c0,7.65-2.55,15.3-2.55,25.5s0,17.85,2.55,25.5l-53.55,43.35
                  c-5.1,5.101-5.1,10.2-2.55,15.301l51,89.25c2.55,2.55,7.649,5.1,15.3,2.55l63.75-25.5c12.75,10.2,28.05,17.85,43.35,25.5
                  l10.2,66.3c0,5.1,5.1,10.2,12.75,10.2h102c5.101,0,12.75-5.101,12.75-10.2l10.2-66.3c15.3-7.65,30.6-15.3,43.35-25.5l63.75,25.5
                  c5.101,2.55,12.75,0,15.301-5.101l51-89.25c2.55-5.1,2.55-12.75-2.551-15.3L440.813,280.5z M252.113,344.25
                  c-48.45,0-89.25-40.8-89.25-89.25s40.8-89.25,89.25-89.25s89.25,40.8,89.25,89.25S300.563,344.25,252.113,344.25z"/>
              </g>
            </g>
          </svg>
        </a>
        <a @click.prevent="$auth.logout()" href="#">
          <svg class="non-transform" width="45" height="46" viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M31.125 18.2084V27.7917C31.125 30.4339 28.9755 32.5834 26.3333 32.5834H22.5C21.971 32.5834 21.5417 32.155 21.5417 31.6251C21.5417 31.0951 21.971 30.6667 22.5 30.6667H26.3333C27.9184 30.6667 29.2083 29.3768 29.2083 27.7917V18.2084C29.2083 16.6233 27.9184 15.3334 26.3333 15.3334H22.5C21.971 15.3334 21.5417 14.905 21.5417 14.3751C21.5417 13.8451 21.971 13.4167 22.5 13.4167H26.3333C28.9755 13.4167 31.125 15.5663 31.125 18.2084ZM25.0942 22.3225L21.2609 18.4892C20.8862 18.1145 20.2805 18.1145 19.9058 18.4892C19.5311 18.8639 19.5311 19.4696 19.9058 19.8443L22.1032 22.0417H14.8333C14.3043 22.0417 13.875 22.4701 13.875 23.0001C13.875 23.53 14.3043 23.9584 14.8333 23.9584H22.1032L19.9058 26.1558C19.5311 26.5306 19.5311 27.1363 19.9058 27.511C20.0927 27.6979 20.338 27.7917 20.5833 27.7917C20.8287 27.7917 21.074 27.6979 21.2609 27.511L25.0942 23.6777C25.4689 23.3029 25.4689 22.6963 25.0942 22.3225Z" fill="#A5A5A5"/>
          </svg>
        </a>
      </template>
    </nav>
  </div>
</template>

<script>
import LoginDialog from "./LoginDialog.vue";
import {eventBus} from "../main";

export default {
  name: "MainMenu",
  components: {LoginDialog},
  data() {
    return {
      showDialog: false
    }
  },
  mounted() {
    eventBus.$on('show:login', () => {
      this.showDialog = true
    })
  },
  methods: {
    login() {
      this.showDialog = true
      return false;
    }
  }
}
</script>
<style lang="scss">
.profile {
  svg {
    max-height: 42px;
    max-width: 42px;
  }
}
</style>